function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, DisplayContext, JSON, Object, inCustomRange, stagedDateRange) {
    var h = require("panel").h;
    const showCustomRange = $attr(`display-context`) == DisplayContext.ImpactTimePicker;
    return {
      value: (h("div", {
        "class": {
          'mp-time-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((inCustomRange || (showCustomRange && stagedDateRange)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu-pane", {
            "attrs": {
              header: 'Select a date range',
              'show-back-button': !showCustomRange
            },
            "on": {
              'back-click': $helpers.onPaneBackClick
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-datepicker-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-date-range-picker", {
                "attrs": Object.assign({
                    'display-context': $attr(`display-context`),
                    'date-range': JSON.stringify($helpers.getDateRangeAttributes()),
                  },
                  $helpers.getUpsellAttrs()
                ),
                "on": {
                  changeDateRange: $helpers.updateStagedDateRange,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
              "attrs": {
                disabled: !$helpers.isStagedDateRangeValid(),
              },
              "on": {
                click: $helpers.selectDateRange,
              },
              "class": {
                'mp-button-bar-primary': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Select date range");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
            "attrs": {
              sections: JSON.stringify($helpers.getMenuSections()),
            },
            "on": {
              clickItem: $helpers.onPresetItemClick
            },
          }));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "DisplayContext" in locals ? locals.DisplayContext : typeof DisplayContext !== "undefined" ? DisplayContext : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "inCustomRange" in locals ? locals.inCustomRange : typeof inCustomRange !== "undefined" ? inCustomRange : undefined, "stagedDateRange" in locals ? locals.stagedDateRange : typeof stagedDateRange !== "undefined" ? stagedDateRange : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;